export default class Fader {
    constructor(elements) {
        this.elements = [];
        this.activeEntries = 0;
        this.event = new Event('fadingIn');
        this.prepareClass = 'toFade';
        this.activeClass = 'fadingIn';
        this.appearDuration = 1000 * 2;
        this.appearDelay = 300;
        this.threshold = 0;
        this.createObserver();

        if (elements !== null && elements !== undefined) {
            this.addElement(elements);
        }
    }

    createObserver() {
        this._io = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.handleIntersection(entry);
                }
            });
        }, {
            threshold: this.threshold,
        });
    }

    handleIntersection(entry) {
        this.activeEntries++;
        setTimeout(() => this.activeEntries--, this.appearDuration);
        setTimeout(() => {
            entry.target.classList.add(this.activeClass);
            entry.target.dispatchEvent(this.event);
            setTimeout(() => {
                entry.target.classList.remove(this.prepareClass);
                entry.target.classList.remove(this.activeClass);
            }, this.appearDuration);
        }, ((this.activeEntries - 1) * this.appearDelay) - (this.appearDelay / this.activeEntries + 2));

        this._io.unobserve(entry.target);
    }

    addElement(element) {
        if (typeof(element) === 'string') {
            document.querySelectorAll(element).forEach(el => {
                el.classList.add(this.prepareClass);
                this.elements.push(el);

                this._io.observe(el);
            });
        } else {
            if (element.length) {
                element.forEach(el => {
                    el.classList.add(this.prepareClass);
                    this.elements.push(el);
        
                    this._io.observe(el);
                });
            } else {
                element.classList.add(this.prepareClass);
                this.elements.push(element);
    
                this._io.observe(element);   
            }
        }
    }
}